import React from 'react';
import I18n from 'i18n-js';

import { RCAccordion, RCIcon, RCTag } from '@reverbdotcom/cadence/components';
import { CheckCircleIcon, ChatsCircleIcon, XCircleIcon } from '@phosphor-icons/react';

import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

import UrlHelpers from '../shared/url_helpers';
import { HOURS_TO_CHECK_OUT_WHEN_CONDITIONALLY_ACCEPTED } from './update_offer_modal';

import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

interface Props {
  isSeller: boolean;
}

export default function OfferActionsExplanation({ isSeller }: Props) {
  const reducedTimeline = useExpEnabled(experiments.REDUCED_OFFER_TIMELINE);

  if (!isSeller) {
    return null;
  }

  return (
    <div className="mb-4">
      <RCAccordion
        id="offer-actions-explanation"
        heading={I18n.t('discovery.offers.actionsExplanation.headline')}
        defaultOpen={true}
      >
        <div className="d-flex mobile-fx-dir-col">
          <div className="width-25 mobile-width-100 mr-6">
            <RCIcon icon={<CheckCircleIcon />} size="inline" spacing="right" />
            <strong>
              {I18n.t('discovery.offers.actionsExplanation.seller.accept.title')}
            </strong>

            <p className="mt-1">
              {I18n.t(`discovery.offers.actionsExplanation.seller.accept.${reducedTimeline ? 'paymentDeadline' : 'body'}`)}
            </p>
          </div>
          <div className="width-25 mobile-width-100 mr-6">
            <RCIcon icon={<ChatsCircleIcon />} size="inline" spacing="right" />
            <strong>
              {I18n.t('discovery.offers.actionsExplanation.seller.counter.title')}
            </strong>

            <p className="mt-1 mb-2">
              {I18n.t('discovery.offers.actionsExplanation.seller.counter.body')}
            </p>

            <RCTag variant="highlight">
              {I18n.t('discovery.offers.actionsExplanation.seller.counter.conditionalAcceptance.getPaidFaster')}
            </RCTag>

            <p>
              {I18n.t('discovery.offers.actionsExplanation.seller.counter.conditionalAcceptance.body', { count: HOURS_TO_CHECK_OUT_WHEN_CONDITIONALLY_ACCEPTED })}
            </p>
          </div>
          <div className="width-25 mobile-width-100">
            <RCIcon icon={<XCircleIcon />} size="inline" spacing="right" />
            <strong>
              {I18n.t('discovery.offers.actionsExplanation.seller.decline.title')}
            </strong>

            <p className="mt-1">
              {I18n.t('discovery.offers.actionsExplanation.seller.decline.body')}
            </p>
          </div>
        </div>

        <div>
          <Translate
            html
            text="discovery.offers.actionsExplanation.seller.setupOfferAutomation"
            args={{
              linkOpen: `<a href="${UrlHelpers.shopPoliciesEditPath}" target="_blank" class="text-link">`,
              linkClose: '</a>',
            }}
          />
        </div>
      </RCAccordion>
    </div>
  );
}
